import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { Modal } from "@gemini/ui";
import { useKeyboardNav } from "@/hooks";
import { Masonry } from "./Masonry";
import { useI18n } from "@/shared/hooks";
import { ModalTopBar } from "@/components/UI";
import { SocialAndPrintCTAs } from "@/shared/components/SocialAndPrintCTAs";
import { useGalleryContext } from "../../contexts/GalleryContext";
import { StickyCta } from "@/components/contacting";
import { ThorView } from "@aviv-dxp/react-thor";
import { useTrackingViewMedias } from "@/hooks/tracking/useTrackingViewMedias";
export const MasonryModal = ({ isOpen, testId }) => {
    const { t } = useI18n();
    const { openSliderModal, closeMasonryModal, toggleMasonryModal, setCurrentStep, } = useGalleryContext();
    const openOnSlideIndex = (index) => {
        setCurrentStep(index);
        openSliderModal();
    };
    useKeyboardNav({
        handleEscape: closeMasonryModal,
    });
    const trackingViewData = useTrackingViewMedias("classified_detail_media_masonry");
    return (_jsxs(Modal, { displayMode: "fullscreen", hasContentPadding: false, hasCloseButton: false, isOpen: isOpen, trigger: () => null, onOpenChange: toggleMasonryModal, testId: `${testId}`, isKeyboardDismissDisabled: true, children: [_jsx(ThorView, { viewProps: trackingViewData }), _jsxs(Box, { backgroundColor: "color.border.constant.white", position: "relative", display: "flex", flexDirection: "column", alignItems: "center", children: [_jsx(ModalTopBar, { testId: `${testId}.TopBar`, closeAction: closeMasonryModal, buttonLabel: t("gallery.modal.back.cta"), additionalCTAs: _jsx(SocialAndPrintCTAs, { variant: "tertiary" }), showContacting: true, showTabs: false, tracking: {
                            avZone: "masonry",
                        } }), _jsx(Masonry, { openOnSlideIndex: openOnSlideIndex, testId: `${testId}.Masonry` }), _jsx(StickyCta, { tracking: { avZone: "masonry" } })] })] }));
};
